import React from "react";
import { Link } from "react-router-dom";
import { FaCar, FaCheck, FaPlus } from "react-icons/fa";
import styles from "./EmptyDashboardCard.module.css";

const EmptyDashboardCard = () => {
    return (
        <section
            className={styles.wrapper}
            dir="rtl"
        >
            <div className={styles.card}>

                {/* <div className={styles.iconWrapper}>
                    <FaCar className={styles.carIcon} />
                </div>

                <h2 className={styles.title}>
                    هنوز سرویسی ثبت نشده است
                </h2>

                <p className={styles.description}>
                    سرویس‌های خودرویتان را ثبت کنید تا سوابق سرویس‌ها
                    و زمان‌بندی سرویس‌های بعدی را اینجا ببینید.
                </p> */}

                {/* مراحل */}
                <div className={styles.steps}>

                    {/* مرحله اول */}
                    <div className={styles.step}>
                        <div
                            className={`${styles.stepCircle} ${styles.completed}`}
                        >
                            <FaCheck size={11} />
                        </div>

                        <span className={styles.stepLabel}>
                            تعریف خودرو
                        </span>
                    </div>

                    <div className={styles.stepLine} />

                    {/* مرحله دوم */}
                    <div className={styles.step}>
                        <div
                            className={`${styles.stepCircle} ${styles.current}`}
                        >
                            <span className={styles.dot} />
                        </div>

                        <span className={styles.stepLabel}>
                            تعریف سرویس
                        </span>
                    </div>

                    <div className={styles.stepLine} />

                    {/* مرحله سوم */}
                    <div className={styles.step}>
                        <div className={styles.stepCircle} />

                        <span className={styles.stepLabel}>
                            ثبت سرویس و ایجاد سابقه
                        </span>
                    </div>

                </div>

                <div className={styles.status}>
                    {/* <span className={styles.statusTitle}>
                        در انتظار شما
                    </span> */}

                    <span className={styles.statusText}>
                       سرویس خودرویتان را تعریف کنید تا زمان انجام آن را به شما یادآوری کنیم
                    </span>
                </div>

                <Link
                    to="/add-service"
                    className={styles.actionButton}
                >
                    <FaPlus style={{ marginLeft: '6px' }} />
                    تعریف سرویس جدید
                </Link>

            </div>
        </section>
    );
};

export default EmptyDashboardCard;
